<template>
  <div class="lv-article-content">
    <div ref="lvArticleContentText">
      <div
        v-if="richContent"
        class="html-text lv-article-content__text ml-0"
        :class="{'lv-article-content__text--collapse': _isCollapse && isActive.collapse}"
        v-html="richContent"
      />
      <div
        v-else
        class="lv-article-content__text"
        :class="{'lv-article-content__text--collapse': _isCollapse && isActive.collapse}"
      >
        <p>{{ content }}</p>
      </div>
    </div>
    <LvFlexBox
      v-if="_isCollapse"
      justifyContent="center"
      class="my-12"
    >
      <WsTextButton001
        primary
        noPadding
        :leadingIcon="isActive.collapse ? 'icon-chevron-down' : 'icon-chevron-up'"
        @click="$_onToggleCollapse"
      >
        {{ $t(isActive.collapse ? '展開' : '收起') }}
      </WsTextButton001>
    </LvFlexBox>
  </div>
</template>

<script>
export default {
  props: {
    richContent: {
      type: String,
    },
    content: {
      type: String,
    },
    isCollapsable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: {
        collapse: true,
      },
      lvArticleContentTextHeight: 0,
    };
  },
  computed: {
    _isCollapse() {
      return this.isCollapsable && this.lvArticleContentTextHeight > 165;
    },
  },
  mounted() {
    this.lvArticleContentTextHeight = this.$refs.lvArticleContentText.clientHeight;
  },
  methods: {
    $_onToggleCollapse() {
      this.isActive.collapse = !this.isActive.collapse;
      this.$emit('toggle-collapse', {
        isCollapse: this.isActive.collapse,
        top: this.$refs.lvArticleContentText.getBoundingClientRect().top,
      });
    },
  },
};
</script>